import { createSlice, createAsyncThunk,createAction } from "@reduxjs/toolkit";
import customerService from "./customerService";

// Get All Users -----------------------
export const getUsers = createAsyncThunk(
  "customer/get-customers",
  async (thunkAPI) => {
    try {
      return await customerService.getUsers();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
// Get A Single User -----------------------
export const getaUser = createAsyncThunk(
  "customer/get-a-customer",
  async (id, thunkAPI) => {
    try {
      return await customerService.getaUser(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
// Create A Single User -----------------------

export const createUser = createAsyncThunk(
  'customer/create-customer',
  async (userData, { rejectWithValue }) => {
    try {
      return await customerService.createUser(userData);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        // If the error response has a status of 400, extract the error message
        const errorMessage = error.response.data.message;
        return rejectWithValue(errorMessage);
      } else {
        // For other errors, just reject with the error message
        return rejectWithValue('Something went wrong');
      }
    }
  }
);

// Update A Single User -----------------------

export const updateUser = createAsyncThunk(
  'customer/update-customer',
  async (userData, { rejectWithValue }) => {
    try {
      return await customerService.updateUser(userData);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        // If the error response has a status of 400, extract the error message
        const errorMessage = error.response.data.message;
        return rejectWithValue(errorMessage);
      } else {
        // For other errors, just reject with the error message
        return rejectWithValue('Something went wrong');
      }
    }
  }
);

export const deleteUser = createAsyncThunk(
  "customer/delete-customer",
  async (id, thunkAPI) => {
    try {
      return await customerService.deleteUser(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const blockAuser = createAsyncThunk(
  "customer/block-user",
  async ({ customerId, isBlocked }, thunkAPI) => {
    try {
      return await customerService.blockCustomer(customerId, isBlocked);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  customers: [],
  customerinfo:[],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: false,
  errorMessage: false,
};

export const customerSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    resetState: (state) => {
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = false;
      state.message = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.customers = action.payload;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getaUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getaUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.customerinfo = action.payload;
        // state.enqMobile = action.payload.mobile;
        // state.enqEmail = action.payload.email;
        // state.enqComment = action.payload.comment;
        // state.enqStatus = action.payload.status;
      })
      .addCase(getaUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdcustomers = action.payload;
      })
      .addCase(createUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.errorMessage = action.payload || action.error.message || 'Something went wrong';
      })
      .addCase(updateUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedcustomers = action.payload;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.errorMessage = action.payload || action.error.message || 'Something went wrong';
      })
      .addCase(blockAuser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(blockAuser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.blockUser = action.payload;
      })
      .addCase(blockAuser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedUser = action.payload;
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});


export default customerSlice.reducer;
